import { applyRtpPlaceholder, formatGameRtp, localizeConfig, type TranslateFn } from './localize'
import { resolveAssetUrls } from '@/utils/AssetsUrlUtil'

export type ConfigItem = Record<string, any>

const rulesConfig: ConfigItem[] = [
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", text: "Rules" },
	{ type: "title", titleCss: "title", align: "center", text: "Soaring Eagle Hold and Win Game Rules" },
	{ type: "pTag", pTagCss: "pTagStyle", align: "center", text: "By playing our games, you agree that you do not find them offensive, unfair or indecent." },
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "How to Play Slots:" },
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"Choose the amount you would like to bet with. Control the bet amount by clicking/tapping plus and minus buttons next to Stake.",
			"Your winnings are automatically added to your account balance. You can see your Total Win displayed in the WIN section of the screen after each spin.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Game Rules:" },
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"The game is played with 20 fixed pay lines and each game costs 20 fixed coins.",
			"All Symbols pay from left to right in consecutive order.",
			"Payouts are made according to the pay table.",
			"Only the Highest win in the winning combination is paid.",
			"Malfunction voids all pays and plays.",
			"The max win limit the player can be awarded is 2000x bet. If there are remaining spins left, player will be awarded max win and round is forfeited.",
			"For this game, the long-term expected payback is {{RTP}}%.",
			'The RTP was calculated by simulating 10 million rounds.'
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Game Features:" },
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Hold And Win Feature:" },
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"6 or more golden coin symbols triggers the Hold and Win feature.",
			"The golden coin credit values from Base game will stick to the window during the transition to the feature.",
			"The game starts with 3 re-spins. All golden coin credit symbols that land after each re-spin remain on the screen until the end of the re-spins.",
			"Every time a new golden coin lands on the reel, the number of re-spins are reset to 3.",
			"The game ends when no re-spins are remaining, or all the golden coin credit symbols are filled up and multiplied with total bet.",
			"If the player fills all 15 positions then they win the Mini Jackpot along with the sum of all credit values.",
			"The Jackpot values are:",
			"Mini – 50x total bet",
			"Minor – 100x total bet",
			"Major – 250x total bet",
			"Grand - 1000x total bet",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Free Game:" },
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"3 Bonus symbols appearing on the base game screen awards 10 free spins.",
			"Free Spins can be re-triggered.  If 3 Bonus symbols appear on the screen during free game, then player will be awarded 10 additional free spins.",
			"6 or more Hold and Win symbols appearing on the Free Game screen awards the Hold and Win feature. The feature can be awarded maximum for 3 times during the free game",
			"Ladder feature is only available during Free Spins game.",
			'Up to 30 additional free spins can be retriggered.',
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Ladder Feature:" },
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"During every free spin whenever player has 5 or less golden coin symbols appearing on screen, they are collected on the Ladder next to the reel.",
			"Keep accumulating the number of golden coin symbols and climb the Ladder throughout the Free Spins.",
			"At the end of the free game, the player gets the credit value corresponding to the accrued milestone.",
			"Jackpots Rewards in this feature:",
			"Mini – 50x total bet",
			"Minor – 100x total bet",
			"Major – 250x total bet",
			"Grand - 1000x total bet",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Buy Feature:" },
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"During the main game, the player will have an option to BUY BONUS.",
			"BUY BONUS price is 80x total bet.",
			"Buy Bonus feature guarantees entry into Free Spins feature.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Game Controls:" },
	{
		type: "pTag",
		pTagCss: "pTagStyle",
		additionalCss: "azPTagStyle",
		align: "center",
		text: "This section lists the different buttons found in the game and describes their functions.",
	},
	{
		type: "table",
		align: "center",
		additionalCss: "testCSS",
		items: [
			[{ type: "text", align: "center", additionalCss: "testCss", text: "Buttons" }, { type: "text", align: "center", additionalCss: "testCss", text: "Function" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "menuBtn.png", imgPath: "/assets/infopages/rules/menuBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open menu" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "infoBtn.png", imgPath: "/assets/infopages/rules/infoBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open the PAYTABLE" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "settingsBtn.png", imgPath: "/assets/infopages/rules/settingsBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open the GAME SETTINGS" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "rulesBtn.png", imgPath: "/assets/infopages/rules/rulesBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open the GAME RULES" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "fullscreenBtn.png", imgPath: "/assets/infopages/rules/fullscreenBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to switch full screen / exit full screen" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "volumeOn.png", imgPath: "/assets/infopages/rules/volumeOn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to switch Sound on / off" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "spinBtn.png", imgPath: "/assets/infopages/rules/spinBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to Spin" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "autospin.png", imgPath: "/assets/infopages/rules/autospin.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open Auto Spin" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "closeBtn.png", imgPath: "/assets/infopages/rules/closeBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap the X button to return to the game" }],
		],
	},
	{
		type: "pTag",
		pTagCss: "pTagStyle",
		additionalCss: "azPTagStyle",
		align: "center",
		text: "You can place restrictions on game play by following any of these options:",
	},
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"Stop on any win: <b>Auto-bet</b> function is stopped when you get any winning combination.",
			"Stop on single win limit: Based on the limit value selected, the Auto-bet function is stopped when your total win in a single game reaches the selected value.",
			"Stop on session loss limit: Based on the limit value selected, the Auto-bet function is stopped when your total loss in the session reaches the selected value, which is derived by bet minus wins.",
		],
	},
	{
		// imgCSS replaces the default content-image class instead of adding to it, so naming a class
		// that infopages.css does not define drops the max-width cap and the 926px screenshot renders
		// at full size, overflowing the portrait content column.
		type: "image",
		align: "center",
		additionalCss: "additionalCss",
		imgName: "autoSpinSettings.png",
		imgPath: "/assets/infopages/rules/autoSpinSettings.png",
	},
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"If the game is interrupted due to connection loss during Free Spins or Bonus Rounds, the game will resume the remaining Free Spins or the pending Bonus Round upon re-opening.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Auto Spin Game Rules:" },
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"<b>Auto Spin</b> is similar to a regular spin, you can choose <b>Auto Spin</b> for a selected number of spins.",
			"As soon as <b>Auto Spin</b> begins, the <b>Auto Spin</b> button is replaced by a counter displaying the remaining <b>Auto-bet</b> rounds. The <b>Auto Spin</b> button changes to the <b>Stop Auto Spin</b> icon.",
			"<b>Auto Spin</b> automatically plays the game for the selected number of rounds.",
			"<b>Auto Spin</b> can be stopped at any time by clicking / tapping the <b>Auto Spin</b> (Auto Stop) button.",
			"<b>Auto Spin</b> settings will return to default when you trigger any Feature round (Free spins / Bonus Round).",
			"If you are disconnected while playing, all <b>Auto-play</b> settings will return to default when you reload the game.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Additional Information:" },
	{
		type: "list",
		align: "left",
		listCss: "bulletListStyle",
		additionalCss: "cssclass",
		text: [
			"Guidance on RTP / Paylines / Bonus Feature / Wild / Free Spins is covered under the Paytable section of respective games. You can access this by clicking / tapping the <b>Paytable</b> button.",
			"Any stakes that you place are non-refundable, unless a system malfunction occurs, in which case, all stakes placed on the particular game being played at the time of the malfunction will be refunded. We have no obligation to repay players who abuse these occurrences, and  therefore, an alternative may be deemed suitable depending on the individual circumstances.",
			"The in-game paytable shows symbol payouts as the multipliers on the total bet amount, which is calculated as 'total bet = (coin value * number of fixed coins)'. Hence the actual payouts  will be coin value * paytable factor when bet lines are kept constant.",
			"If a query arises as a result of a gaming session, where there is a mismatch between your  records and the data recorded by our servers, the latter will be considered correct.",
			"In the event of any disagreement between yourself and this website, the management's decision will be considered final.",
			"If the game is interrupted due to connection loss, <b>Balance</b> and <b>Win</b> information  can be viewed using Game Logs.",
			"In the event of malfunction of gaming hardware / software, all affected game bets and payouts are rendered void and all affected bets refunded.",
		],
	},
]

export const getRulesConfig = (translate: TranslateFn, rtp?: unknown): ConfigItem[] =>
	resolveAssetUrls(applyRtpPlaceholder(localizeConfig(rulesConfig, translate), formatGameRtp(rtp)))
